<mat-form-field>
  <input
    matInput
    [placeholder]="'pages.localisation.interface.input_placeholder' | translate"
    #destination
  >
</mat-form-field>



// WEBPACK FOOTER //
// ./src/app/common-theme/gmaps/location-search-input/location-search-input.component.html